class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.sticky-add-to-cart__button');
    this.button.addEventListener('click', this.onClick.bind(this));
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    this.mainButton = document.querySelector('main .product-form__submit');
    if (!this.mainButton) return;

    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }

  update() {
    const rect = this.mainButton.getBoundingClientRect();
    const mainButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    this.classList.toggle('sticky-add-to-cart--visible', !mainButtonVisible);
  }

  onClick() {
    if (this.mainButton) this.mainButton.click();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
